import ViewReverse from '../../../components/ViewReverse';
import dynamicfunction from '../../../utils/dynamicfunction';
import { fontSizes } from '../../../constants/constants';
import { Dropdown, ErrorText, InputField, PhoneInput, RadioButton, Text } from '../../../components/SecondaryMarket';
import icons from '../../../constants/icons';
import { useState } from 'react';
import ViewItems from '../../../components/ViewItems';
import { ReactSVG } from 'react-svg';
import { cn, formatNumbers, getContentKeyAccToLang } from '../../../utils/utils';
import { useSelector } from 'react-redux';
import { Formik } from 'formik';
import { contact_information_schema, contact_information_validation_schema } from '../../../validations_schemas/contact_information_validation_schema';
import { isEmptyValue, alphabet_regix, getRejectedFieldData, numeric_integer_regix, splitPhoneNumberAndCode } from '../../../utils/functions';

const ContactInformation = ({ isKYC, isOpen = true, setStep, contentKey, formRef, percentage }) => {
  const { TextWeight, isArabic } = dynamicfunction();

  const corpKycContent = useSelector((state) => state.content?.corpKycContent);
  const corpAOContent = useSelector((state) => state.content?.corpAOContent);
  const { corporate_kyc_data, corporate_dropdown_data, rejection_summary, is_rejected, field_codes } = useSelector((state) => state.corporate);

  const getContentKey = (key) => {
    const content = isKYC ? corpKycContent : corpAOContent;
    return getContentKeyAccToLang(content?.[contentKey]?.data?.attributes, key, isArabic);
  };

  const rejectedFields = rejection_summary?.find(item => item?.sectionId === 3)?.rejectedFields || [];
  const languageRejectedField = rejectedFields?.length < 1 ? null : getRejectedFieldData(rejectedFields, field_codes, 'legalStructure');

  const contactInformationData = isKYC ? corporate_kyc_data?.kycContactPersonInfo : corporate_kyc_data?.accountOpeningContactPersonInfo;


  return (
    <div>
      <ViewReverse className={cn('w-full items-center gap-2 justify-between', isKYC && 'cursor-pointer')} onClick={() => isKYC && setStep(2)}>
        <ViewReverse className="flex items-center gap-2">
          <Text text={getContentKey('contact_information')} weight={TextWeight.headingRegular} className={'text-dark-blue'} size={fontSizes.h30} />
          {rejectedFields?.length > 0 && <ReactSVG src={icons.heading_info_outline_icon} />}
        </ViewReverse>

        <ViewReverse className={'items-center gap-2'}>
          <Text text={`${formatNumbers(percentage) ?? 0}%`} className={'text-dark-blue'} size={fontSizes.h14} />
          {isKYC && <ReactSVG src={icons.downArrow} className={cn(isOpen ? 'rotate-180' : 'rotate-0')} />}
        </ViewReverse>
      </ViewReverse>

      <Formik
        innerRef={formRef}
        enableReinitialize
        initialValues={contact_information_schema(contactInformationData)}
        validationSchema={contact_information_validation_schema}
        onSubmit={() => { }}
        validateOnChange={false}
        validateOnMount={false}
        validateOnBlur={false}
      >
        {({ values, errors, setFieldValue, setFieldError }) => (
          isOpen && (
            <>
              <div className='mt-8 mb-9 h-[1px] bg-black/10' />

              <Text text={getContentKey('contact_person_information')} className={'text-light-blue'} size={fontSizes.h22} />

              <div className='space-y-6'>
                <ViewReverse className={'gap-6 mt-8'} isResponsive>
                  <InputField
                    label={getContentKey('contact_person')}
                    isRequired
                    isArabicAllowed
                    maxLength={50}
                    placeholder={getContentKey('enter_contact_person')}
                    value={values?.contactPersonName}
                    onChange={(text) => {
                      if (alphabet_regix.test(text)) {
                        setFieldValue('contactPersonName', text);
                        setFieldError('contactPersonName', null);
                      }
                    }}
                    error={getContentKey(errors?.contactPersonName)}
                    remarksMetadata={values?.contactPersonName !== contactInformationData?.contactPersonName ? null : {
                      sectionId: 3,
                      key: 'contactPersonName',
                    }}
                  />
                  <InputField
                    label={getContentKey('job_title')}
                    isRequired
                    isArabicAllowed
                    placeholder={getContentKey('enter_job_title')}
                    value={values?.jobTitle}
                    maxLength={50}
                    onChange={(text) => {
                      if (alphabet_regix.test(text)) {
                        setFieldValue('jobTitle', text);
                        setFieldError('jobTitle', null);
                      }
                    }}
                    error={getContentKey(errors?.jobTitle)}
                    remarksMetadata={values?.jobTitle !== contactInformationData?.jobTitle ? null : {
                      sectionId: 3,
                      key: 'jobTitle',
                    }}
                  />
                  <ViewItems className={'w-full'}>
                    <PhoneInput
                      label={getContentKey('work_phone_number')}
                      placeholder={getContentKey('enter_work_phone_number')}
                      value={values?.workPhoneNumber}
                      isRequired={false}
                      
                      country={values?.workPhoneCountry}
                      setCountry={(country) => setFieldValue('workPhoneCountry', country)}
                      onChange={(text, isValid) => {
                        if (numeric_integer_regix.test(text)) {
                          setFieldValue('workPhoneNumber', text, false);
                        }

                        if (!isValid) {
                          setFieldError('workPhoneNumber', 'invalid_phone_number');
                        } else {
                          setFieldError('workPhoneNumber', undefined);
                        }
                      }}
                      remarksMetadata={values?.workPhoneNumber !== splitPhoneNumberAndCode(contactInformationData?.workPhoneNumber)?.number ? null : {
                        sectionId: 3,
                        key: 'workPhoneNumber',
                      }}
                    />
                    <ErrorText text={getContentKey(errors?.workPhoneNumber)} />
                  </ViewItems>
                </ViewReverse>

                <ViewReverse className={'gap-6 mt-8'} isResponsive>
                  <ViewItems className={'w-full'}>
                    <PhoneInput
                      label={getContentKey('mobile_number')}
                      placeholder={getContentKey('enter_mobile_number')}
                      value={values?.mobileNumber}
                      country={values?.mobileNumberCountry}
                      setCountry={(country) => setFieldValue('mobileNumberCountry', country)}
                      onChange={(text, isValid) => {
                        if (numeric_integer_regix.test(text)) {
                          setFieldValue('mobileNumber', text, false);
                        }
                        if (!isValid) {
                          setFieldError('mobileNumber', 'invalid_phone_number');
                        } else {
                          setFieldError('mobileNumber', undefined);
                        }
                      }}
                      remarksMetadata={values?.mobileNumber !== splitPhoneNumberAndCode(contactInformationData?.mobileNumber)?.number ? null : {
                        sectionId: 3,
                        key: 'mobileNumber',
                      }}
                    />
                    <ErrorText text={getContentKey(errors?.mobileNumber)} />
                  </ViewItems>
                  <InputField
                    label={getContentKey('address')}
                    isRequired
                    isArabicAllowed
                    isDisabled={is_rejected ? false : contactInformationData?.isAddressFetchByWathq}
                    placeholder={getContentKey('enter_address')}
                    value={values?.address}
                    maxLength={100}
                    onChange={(text) => {
                      setFieldValue('address', text);
                      setFieldError('address', null);
                    }}
                    error={getContentKey(errors?.address)}
                    remarksMetadata={values?.address !== contactInformationData?.address ? null : {
                      sectionId: 3,
                      key: 'address',
                    }}
                  />
                  <InputField
                    label={getContentKey('work_email')}
                    isRequired
                    placeholder={getContentKey('enter_work_email')}
                    value={values?.workEmail}
                    maxLength={50}
                    onChange={(text) => {
                      setFieldValue('workEmail', text);
                      setFieldError('workEmail', null);
                    }}
                    error={getContentKey(errors?.workEmail)}
                    remarksMetadata={values?.workEmail !== contactInformationData?.workEmail ? null : {
                      sectionId: 3,
                      key: 'workEmail',
                    }}
                  />
                </ViewReverse>

                <ViewItems className={'space-y-4'}>
                  <Text text={getContentKey('preferred_language')} isEmpty={isEmptyValue(values?.preferredLanguageForCorrespondence)} className={'text-primary-light'} size={fontSizes.h14} isRequired />
                  <ViewReverse className={'gap-6'}>
                    {
                      corporate_dropdown_data?.preferedLanguage?.map((item, index) => (
                        <RadioButton
                          label={item?.name}
                          selected={values?.preferredLanguageForCorrespondence === item?.id}
                          onClick={() => {
                            if (values?.preferredLanguageForCorrespondence === item?.id) {
                              setFieldValue('preferredLanguageForCorrespondence', null);
                              setFieldError('preferredLanguageForCorrespondence', null);
                            } else {
                              setFieldValue('preferredLanguageForCorrespondence', item?.id);
                              setFieldError('preferredLanguageForCorrespondence', null);
                            }
                          }}
                          remarksMetadata={values?.preferredLanguageForCorrespondence !== contactInformationData?.preferredLanguageForCorrespondence ? null : {
                            sectionId: 3,
                            key: 'preferredLanguageForCorrespondence',
                          }}
                        />
                      ))
                    }
                  </ViewReverse>
                  {
                    values?.preferredLanguageForCorrespondence === contactInformationData?.preferredLanguageForCorrespondence && languageRejectedField?.remarks?.length > 0 && (
                      <ViewReverse className='items-center gap-2 mt-2'>
                        <ReactSVG src={icons.field_info_outline} />
                        <ErrorText text={languageRejectedField?.remarks} className={'mt-0'} />
                      </ViewReverse>
                    )
                  }
                  <ErrorText text={getContentKey(errors?.preferredLanguageForCorrespondence)} />
                </ViewItems>

                <ViewReverse className='items-center gap-2 !mt-10 p-4 w-full bg-light-background rounded-lg'>
                  <ReactSVG src={icons.info_blue} />
                  <Text text={getContentKey('email_disclaimer')} weight={TextWeight.medium} />
                </ViewReverse>
              </div>

              <div className='my-10 h-[1px] bg-black/10' />

              <Text text={getContentKey('registered_address')} weight={TextWeight.medium} className={'text-light-blue'} size={fontSizes.h22} />

              <div className='space-y-6'>
                <ViewReverse className={'gap-6 mt-8'} isResponsive>
                  <InputField
                    label={getContentKey('building_number')}
                    isRequired
                    isDisabled={is_rejected ? false : contactInformationData?.isBuildingNumberKsaFetchByWathq}
                    placeholder={getContentKey('enter_building_number')}
                    value={values?.buildingNumberKsa}
                    onChange={(text) => {
                      setFieldValue('buildingNumberKsa', text);
                      setFieldError('buildingNumberKsa', null);
                    }}
                    error={getContentKey(errors?.buildingNumberKsa)}
                    remarksMetadata={values?.buildingNumberKsa !== contactInformationData?.buildingNumberKsa ? null : {
                      sectionId: 3,
                      key: 'buildingNumberKsa',
                    }}
                  />
                  <InputField
                    label={getContentKey('street_name')}
                    isRequired
                    isArabicAllowed
                    isDisabled={is_rejected ? false : contactInformationData?.isStreetNameKsaFetchByWathq}
                    placeholder={getContentKey('enter_street_name')}
                    value={values?.streetNameKsa}
                    onChange={(text) => {
                      setFieldValue('streetNameKsa', text);
                      setFieldError('streetNameKsa', null);
                    }}
                    error={getContentKey(errors?.streetNameKsa)}
                    remarksMetadata={values?.streetNameKsa !== contactInformationData?.streetNameKsa ? null : {
                      sectionId: 3,
                      key: 'streetNameKsa',
                    }}
                  />
                  <InputField
                    label={getContentKey('district')}
                    isRequired
                    isArabicAllowed
                    isDisabled={is_rejected ? false : contactInformationData?.isDistrictKsaFetchByWathq}
                    placeholder={getContentKey('enter_district')}
                    value={values?.districtKsa}
                    onChange={(text) => {
                      setFieldValue('districtKsa', text);
                      setFieldError('districtKsa', null);
                    }}
                    error={getContentKey(errors?.districtKsa)}
                    remarksMetadata={values?.districtKsa !== contactInformationData?.districtKsa ? null : {
                      sectionId: 3,
                      key: 'districtKsa',
                    }}
                  />
                </ViewReverse>

                <ViewReverse className={'gap-6 mt-8'} isResponsive>
                  <InputField
                    label={getContentKey('city')}
                    isRequired
                    isArabicAllowed
                    isDisabled={is_rejected ? false : contactInformationData?.isCityKsaFetchByWathq}
                    placeholder={getContentKey('enter_city')}
                    value={values?.cityKsa}
                    onChange={(text) => {
                      setFieldValue('cityKsa', text);
                      setFieldError('cityKsa', null);
                    }}
                    error={getContentKey(errors?.cityKsa)}
                    remarksMetadata={values?.cityKsa !== contactInformationData?.cityKsa ? null : {
                      sectionId: 3,
                      key: 'cityKsa',
                    }}
                  />
                  <InputField
                    label={getContentKey('postal_code')}
                    isRequired
                    isDisabled={is_rejected ? false : contactInformationData?.isPostalCodeKsaFetchByWathq}
                    placeholder={getContentKey('enter_postal_code')}
                    value={values?.postalCodeKsa}
                    onChange={(text) => {
                      if (numeric_integer_regix.test(text)) {
                        setFieldValue('postalCodeKsa', text);
                        setFieldError('postalCodeKsa', null);
                      }
                    }}
                    error={getContentKey(errors?.postalCodeKsa)}
                    remarksMetadata={values?.postalCodeKsa !== contactInformationData?.postalCodeKsa ? null : {
                      sectionId: 3,
                      key: 'postalCodeKsa',
                    }}
                  />
                  <InputField
                    label={getContentKey('additional_number')}
                    isRequired
                    isDisabled={is_rejected ? false : contactInformationData?.isAdditionalNumberKsaFetchByWathq}
                    placeholder={getContentKey('enter_additional_number')}
                    value={values?.additionalNumberKsa}
                    onChange={(text) => {
                      if (numeric_integer_regix.test(text)) {
                        setFieldValue('additionalNumberKsa', text);
                        setFieldError('additionalNumberKsa', null);
                      }
                    }}
                    error={getContentKey(errors?.additionalNumberKsa)}
                    remarksMetadata={values?.additionalNumberKsa !== contactInformationData?.additionalNumberKsa ? null : {
                      sectionId: 3,
                      key: 'additionalNumberKsa',
                    }}
                  />
                </ViewReverse>

                <ViewReverse className={'gap-6 mt-8'} isResponsive>
                  <InputField
                    label={getContentKey('unit_no')}
                    isRequired
                    isDisabled={is_rejected ? false : contactInformationData?.isUnitNoKsaFetchByWathq}
                    placeholder={getContentKey('enter_unit_no')}
                    value={values?.unitNoKsa}
                    onChange={(text) => {
                      setFieldValue('unitNoKsa', text);
                      setFieldError('unitNoKsa', null);
                    }}
                    error={getContentKey(errors?.unitNoKsa)}
                    remarksMetadata={values?.unitNoKsa !== contactInformationData?.unitNoKsa ? null : {
                      sectionId: 3,
                      key: 'unitNoKsa',
                    }}
                  />
                  <div className='w-full hidden md:flex' />
                  <div className='w-full hidden md:flex' />
                </ViewReverse>
              </div>

              {/* <div className='my-10 h-[1px] bg-black/10' />

              <Text text={getContentKey('registered_address_non_ksa')} weight={TextWeight.medium} className={'text-light-blue'} size={fontSizes.h22} />

              <div className='space-y-6'>
                <ViewReverse className={'gap-6 mt-8'} isResponsive>
                  <InputField
                    label={getContentKey('address')}
                    isRequired
                    placeholder={getContentKey('enter_address')}
                    value={values?.addressNonKsa}
                    onChange={(text) => {
                      setFieldValue('addressNonKsa', text);
                      setFieldError('addressNonKsa', null);
                    }}
                    error={getContentKey(errors?.addressNonKsa)}
                    remarksMetadata={values?.addressNonKsa !== contactInformationData?.addressNonKsa ? null : {
                      sectionId: 3,
                      key: 'addressNonKsa',
                    }}
                  />
                  <div className='w-full hidden md:flex' />
                  <div className='w-full hidden md:flex' />
                </ViewReverse>

                <ViewReverse className={'gap-6 mt-8'} isResponsive>
                  <InputField
                    label={getContentKey('city')}
                    isRequired
                    placeholder={getContentKey('enter_city')}
                    value={values?.cityNonKsa}
                    onChange={(text) => {
                      setFieldValue('cityNonKsa', text);
                      setFieldError('cityNonKsa', null);
                    }}
                    error={getContentKey(errors?.cityNonKsa)}
                    remarksMetadata={values?.cityNonKsa !== contactInformationData?.cityNonKsa ? null : {
                      sectionId: 3,
                      key: 'cityNonKsa',
                    }}
                  />
                  <InputField
                    label={getContentKey('postal_zip_code')}
                    isRequired
                    placeholder={getContentKey('enter_postal_zip_code')}
                    value={values?.postalOrZipCodeNonKsa}
                    onChange={(text) => {
                      setFieldValue('postalOrZipCodeNonKsa', text);
                      setFieldError('postalOrZipCodeNonKsa', null);
                    }}
                    error={getContentKey(errors?.postalOrZipCodeNonKsa)}
                    remarksMetadata={values?.postalOrZipCodeNonKsa !== contactInformationData?.postalOrZipCodeNonKsa ? null : {
                      sectionId: 3,
                      key: 'postalOrZipCodeNonKsa',
                    }}
                  />
                  <div className='w-full hidden md:flex' />
                </ViewReverse>

                <ViewReverse className={'gap-6 mt-8'} isResponsive>
                  <InputField
                    label={getContentKey('province_state_region')}
                    isRequired
                    placeholder={getContentKey('enter_province_state_region')}
                    value={values?.provinceStateOrRegionNonKsa}
                    onChange={(text) => {
                      setFieldValue('provinceStateOrRegionNonKsa', text);
                      setFieldError('provinceStateOrRegionNonKsa', null);
                    }}
                    error={getContentKey(errors?.provinceStateOrRegionNonKsa)}
                    remarksMetadata={values?.provinceStateOrRegionNonKsa !== contactInformationData?.provinceStateOrRegionNonKsa ? null : {
                      sectionId: 3,
                      key: 'provinceStateOrRegionNonKsa',
                    }}
                  />
                  <Dropdown
                    label={getContentKey('country')}
                    placeholder={getContentKey('country')}
                    value={corporate_dropdown_data?.country?.find(country => values?.countryNonKsa === country?.id)}
                    valueKey={'name'}
                    options={corporate_dropdown_data?.country}
                    onSelect={(country) => {
                      setFieldValue('countryNonKsa', country?.id);
                      setFieldError('countryNonKsa', null);
                    }}
                    error={getContentKey(errors?.countryNonKsa)}
                    remarksMetadata={values?.countryNonKsa !== contactInformationData?.countryNonKsa ? null : {
                      sectionId: 3,
                      key: 'countryNonKsa',
                    }}
                  />
                  <div className='w-full hidden md:flex' />
                </ViewReverse>
              </div> */}
            </>
          )
        )}
      </Formik>
    </div>
  );
};

export default ContactInformation;
